import { useState, useEffect } from 'react';

const useStateWithCallback = (initialState, callback) => {
    const [state, setState] = useState(initialState);
    useEffect(() => callback(state), [state]);
    return [state, setState];
};

export default useStateWithCallback;
